import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a7b84abd-e0a9-435b-8ed5-792c276abc76",
    content: "Minimize the potential energy in the dark zone",
    options: {},
  },
  {
    id: "4883277d-bde3-4936-aaac-dac7e514a8e8",
    content: "Minimize the potential energy in the bright zone",
    options: {},
  },
  {
    id: "ddf8a484-b146-40cd-810a-90dc684d6cd8",
    content: "Maximize the potential energy in the dark zone",
    options: {},
  },
  {
    id: "94ff269b-4dea-4e62-ba17-6962d488067c",
    content: "Maximize the potential energy in the bright zone",
    options: {},
  },
  {
    id: "61df63d6-5ded-47d5-8326-6ba0c51bf968",
    content: "Minimize the error to the target pressure in the dark zone",
    options: {},
  },
  {
    id: "891803f7-6dfa-4855-aa78-5d94348bce80",
    content: "Minimize the error to the target pressure in the bright zone",
    options: {},
  },
];

export const task: Task = {
  id: "e1772c53-5641-4c51-9bd1-3cce3df2c34e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a7b84abd-e0a9-435b-8ed5-792c276abc76", "891803f7-6dfa-4855-aa78-5d94348bce80"],
};
